module.exports = __webpack_public_path__ + "static/media/caution.631282f5.svg";